<template>
    <div class = "rfoot_flex">
        <div class = "rfoot_cont">
            <router-link to="/index" tag="a">全部服务</router-link>
            <span>|</span>
            <a>济邦邦财税 — 为创业者提供“星”级服务！</a>
            <span>|</span>
            <a target="_blank" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=5d03cb84434f42888ac1e80648748afe&sid=5d03cb84434f42888ac1e80648748afe">联系我们</a>
            <span>|</span>
            <a>法律声明</a>
            <span class = "tel"><b>客服电话：</b>{{commonVal.phone}}</span>
        </div>
        <a :href="commonVal.copyrightLink" target="_blank" class="commonA">{{commonVal.copyrightDescr}}</a>
    </div>
</template>
<script>
export default {
    data(){
        return{
            commonVal:'',
        }
    },
    mounted() {
        this.getCommonVal()
    },
    methods: {
        // 底部配置数据
        getCommonVal(){
            this.$axios({
                method:'get',
                url:'/jbbcs/owManage/cusWebConfig/getInfoByWebName',
                params:{
                    webName:'1',
                }
            }).then((res) =>{
                if(res.data.code==1){
                    this.commonVal=res.data.content
                }else if(res.data.code==0){
                    this.$message.error(res.data.msg);
                }
            }).catch((error) =>{
                this.$message.error('操作失败，请重试');
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.rfoot_flex{
    text-align: center;
    padding-top: 50px;
    padding-bottom: 50px;
    a{
        margin-left: 3px;
        margin-right: 3px;
        color: #505050;
        cursor: pointer;
    }
    span{
        margin-left: 3px;
        margin-right: 3px;
        color: #505050;
    }
    .tel{
        margin-left: 50px;
        b{
            font-weight: 700;
        }
    }
    p{
        margin-top: 20px;
    }
    .commonA{
        display: block;
        margin-top:20px;
    }

}
</style>




// WEBPACK FOOTER //
// src/components/registerLogin/rfoot.vue